import { render, staticRenderFns } from "./TileProductGiveaway.vue?vue&type=template&id=03abe1a4"
import script from "./TileProductGiveaway.vue?vue&type=script&lang=js"
export * from "./TileProductGiveaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports